import classNames from 'classnames'

import { faFolderTree } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Menu } from '@headlessui/react'
import { Trans } from '@lingui/macro'

import styles from '../../../Content/MenuItems/Associate/index.module.css'
import { useAssociation } from '../../AssociationContext'

interface Props {
  id: string
}

const AssociateToFolder = ({ id }: Props) => {
  const { openAssociation } = useAssociation()

  return (
    <Menu.Item>
      {({ active, ...props }) => (
        <button
          className={classNames(
            active ? styles.active : styles.notActive,
            styles.item,
            'group'
          )}
          onClick={() => openAssociation(id)}
          {...props}
        >
          <FontAwesomeIcon className={styles.icon} icon={faFolderTree} />
          <Trans>Associa a una Bacheca</Trans>
        </button>
      )}
    </Menu.Item>
  )
}

export default AssociateToFolder
